import withContainer from './container'
import Component from './component'

export default withContainer(Component)